import Vue from "vue";
import VueI18n from 'vue-i18n'
import merge from 'deepmerge'

import baseMessages from '../modules/base/i18n/messages'
import marcaMessages from '../modules/marca/i18n/messages'
import proveedorMessages from '../modules/proveedor/i18n/messages'
import depositoMessages from '../modules/deposito/i18n/messages'
import modeloMessages from '../modules/modelo/i18n/messages'
import tamanioMessages from '../modules/tamanio/i18n/messages'
import productoMessages from '../modules/producto/i18n/messages'
import recargoMessages from '../modules/recargo/i18n/messages'
import movimientoMessages from '../modules/movimiento/i18n/messages'
import dashboardMessages from '../modules/dashboard/i18n/messages'
import userConfigurationMessages from '../modules/user-configuration/i18n/messages'
import ofertaMessages from '../modules/oferta/i18n/messages'
import clienteMessages from '../modules/cliente/i18n/messages'
import mediaMessages from '../modules/media/i18n/messages'
import importarProductosMessages from '../modules/importar-productos/i18n/messages'
import compararPreciosProveedorMessages from '../modules/comparar-precios-proveedor/i18n/messages'
import importarListaPreciosMessages from '../modules/importar-lista-precios/i18n/messages'
import facturacionMessages from '../modules/facturacion/i18n/messages'
import registroActividadMessages from '../modules/registro-actividades/i18n/messages'
import ventasMessages from '../modules/ventas/i18n/messages'
import listaPreciosVentaMessages from '../modules/lista-precios-venta/i18n/messages'
import menuMessages from '../menu-config/menu-i18n'
import { i18nMessages as i18nMessagesCommon } from '@dracul/common-frontend'
import { i18nMessages as i18nMessagesUser } from '@dracul/user-frontend'
import { i18nMessages as i18nMessagesCustom } from '@dracul/customize-frontend'
import { i18nMessages as i18nMessagesNotification } from '@dracul/notification-frontend'

const messages = merge.all([
    baseMessages,
    movimientoMessages,
    productoMessages,
    tamanioMessages,
    modeloMessages,
    marcaMessages,
    proveedorMessages,
    recargoMessages,
    depositoMessages,
    mediaMessages,
    importarProductosMessages,
    compararPreciosProveedorMessages,
    importarListaPreciosMessages,
    dashboardMessages,
    userConfigurationMessages,
    ofertaMessages,
    clienteMessages,
    facturacionMessages,
    registroActividadMessages,
    ventasMessages,
    listaPreciosVentaMessages,
    menuMessages,
    i18nMessagesCommon,
    i18nMessagesUser,
    i18nMessagesCustom,
    i18nMessagesNotification
])

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'es',
    messages,
})

export default i18n
